import { disputeSchema_ } from "@redotech/redo-dispute-db-schema/dispute-definition";
import { disputeEvidenceSchema_ } from "@redotech/redo-dispute-db-schema/dispute-evidence-definition";
import { TrackerSchema } from "@redotech/redo-model/order-schema";
import * as z from "zod/v4";

const fulfillmentTrackerSchema_ = z.object({
  _tracker: TrackerSchema,
  fulfillmentID: z.string().nullish(),
  locationId: z.string().nullish(),
});
export const fulfillmentTrackerSchema: z.ZodType<DisputeFulfillmentTracker> =
  fulfillmentTrackerSchema_;
export interface DisputeFulfillmentTracker
  extends z.infer<typeof fulfillmentTrackerSchema_> {}

const disputePaymentInfoSchema_ = z.object({
  bin: z.string().nullish(),
  cardBrand: z.string().nullish(),
  lastFour: z.string().nullish(),
  cardholderName: z.string().nullish(),
  avsResultCode: z.string().nullish(),
  cvvResultCode: z.string().nullish(),
});
export const disputePaymentInfoSchema: z.ZodType<DisputePaymentInfo> =
  disputePaymentInfoSchema_;
export interface DisputePaymentInfo
  extends z.infer<typeof disputePaymentInfoSchema_> {}

const disputeViewSchema_ = disputeSchema_.extend({
  orderName: z.string().nullish(),
  customerName: z.string().nullish(),
  evidence: disputeEvidenceSchema_.nullish(),
  trackers: z.array(fulfillmentTrackerSchema_).nullish(),
  orderTrackingEnabled: z.boolean().nullish(),
  orderId: z.string().nullish(),
  paymentInfo: disputePaymentInfoSchema_.nullish(),
});

export const disputeViewSchema: z.ZodType<DisputeView> = disputeViewSchema_;
export interface DisputeView extends z.infer<typeof disputeViewSchema_> {}
